import axios, { AxiosRequestConfig } from "axios";
import { userInfoService } from "./userInfo";
import { urlPrefix } from "src/utils";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

declare module "axios" {
  interface AxiosInstance {
    setAuthToken(token: string): void;
  }
}

export const getRefreshToken = async () => {
  const org = localStorage.getItem("organizationName");
  const currentUrl = window.location.origin;
  try {

    const refreshToken = localStorage.getItem("refreshToken") || null;
    if (!refreshToken && !org) {
      return (window.location.href = process.env.REACT_APP_DEFAULT_REDIRECT_URL + "?callbackUrl=" + currentUrl )
    }
    const newToken = await userInfoService.refreshToken(refreshToken);
    localStorage.setItem("token", `Bearer ${newToken.data.access_token}`);
    return newToken;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
              return (window.location.href = process.env.REACT_APP_AUTH_REDIRECT_URL + "login?redirect_uri=" + currentUrl + "&client_id=" + process.env.REACT_APP_CLIENT_ID)
          }else {
            return (window.location.href = (`https://${urlPrefix(org)}` + (process.env.REACT_APP_REDIRECT_URL + "?callbackUrl=" + currentUrl)))
          
          }
    }
    throw new Error("Failed to fetch endpoints");
  }
};
// Add method to set auth token
axiosInstance.setAuthToken = (token: string) => {
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = token;
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
  }
};


let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

const onRefreshed = async (token: string) => {
  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  await sleep(2000);
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config as AxiosRequestConfig & {
      _retry?: boolean;
    };
    const org = localStorage.getItem("organizationName");

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const currentUrl = window.location.origin;
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const refreshToken = localStorage.getItem("refreshToken") || null;
          if (!refreshToken && !org) {
              if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
              return (window.location.href = process.env.REACT_APP_AUTH_REDIRECT_URL + "login?redirect_uri=" + currentUrl + "&client_id=" + process.env.REACT_APP_CLIENT_ID)
          }else {
          return (window.location.href = process.env.REACT_APP_DEFAULT_REDIRECT_URL + "?callbackUrl=" + currentUrl)
          }

          }
          const response = await userInfoService.refreshToken(refreshToken);
          const newToken = response.data.access_token;
          localStorage.setItem("token", `Bearer ${newToken}`);

          onRefreshed(newToken);
          isRefreshing = false;
        } catch (err) {
          isRefreshing = false;
          if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
              return (window.location.href = process.env.REACT_APP_AUTH_REDIRECT_URL + "login?redirect_uri=" + currentUrl + "&client_id=" + process.env.REACT_APP_CLIENT_ID)
          }else {
            return (window.location.href = (`https://${urlPrefix(org)}` + (process.env.REACT_APP_REDIRECT_URL + "?callbackUrl=" + currentUrl)))
          
          }
            
        }
      }
      return new Promise((resolve) => {
        refreshSubscribers.push((token: string) => {
          originalRequest.headers = {
            ...originalRequest.headers,
            Authorization: `${token}`,
          };
          resolve(axiosInstance(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use((config: any) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `${token}`,
    };
  }
  return config;
});

export default axiosInstance;